import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import TestPrint from '../components/trends/TestPrint';

import DashboardLayout from './DashboardLayout';
import ErrorLayout from './ErrorLayout';

import loadable from '@loadable/component';
const AuthBasicLayout = loadable(() => import('./AuthBasicLayout'));
const Landing = loadable(() => import('../components/landing/Landing'));
const WizardLayout = loadable(() => import('../components/auth/wizard/WizardLayout'));
const AuthCardRoutes = loadable(() => import('../components/auth/card/AuthCardRoutes'));
const AuthSplitRoutes = loadable(() => import('../components/auth/split/AuthSplitRoutes'));

const Layout = () => {
  useEffect(() => {
    AuthBasicLayout.preload();
    Landing.preload();
    WizardLayout.preload();
    AuthCardRoutes.preload();
    AuthSplitRoutes.preload();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/landing" element={<Landing />} />
        <Route path="/authentication/card/*" element={<AuthCardRoutes />} />
        <Route path="/authentication/split/*" element={<AuthSplitRoutes />} />
        <Route path="/authentication/wizard/*" element={<WizardLayout />} />
        <Route path="/errors/*" element={<ErrorLayout />} />
        <Route path="/authentication/basic/*" element={<AuthBasicLayout />} />
        <Route path="/testprint" element={<TestPrint />} />
        <Route path="/*" element={<DashboardLayout />} />
      </Routes>
    </Router>
  );
};

export default Layout;
